import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchEntitiesTypes = getApiActionTypes('ADMIN/FETCH_LOCK_RETURN_ENTITIES');
export const updateEntitiesTypes = getApiActionTypes('ADMIN/UPDATE_ENTITES_LOCK_STATE');
